export const quotations = {
  breadcrumb: {
    overview: 'Offertes',
    noTitle: 'Geen titel',
    create: 'Offerte details',
  },
  alerts: {
    errorDuplicateEntryNumber: 'Het offertenummer "{{entryNumber}}" is al in gebruik.',
    missingFcFiles_one: 'De PDF voor deze offerte kan niet worden teruggevonden.',
    missingFcFiles_other: "De PDF's voor deze offertes kunnen niet worden teruggevonden.",
    successCreated: 'Je offerte werd succesvol aangemaakt!',
    successDeleted: 'Je concept werd succesvol verwijderd!',
    successUpdated: 'Je offerte werd succesvol bewerkt!',
  },
  clientAccept: {
    card: {
      button: 'Accepteer offerte',
      description: {
        accept: 'Ga je akkoord met de offerte van {{user}}? Accepteer deze dan via onderstaande knop.',
        accepted: 'De offerte werd aangeduid als geaccepteerd.',
        declined: 'De offerte werd aangeduid als afgewezen.',
        expired: 'De offerte is vervallen en kan niet meer goedgekeurd worden.',
      },
      title: 'Offerte van {{user}}',
    },
    preview: {
      assignment: {
        title: 'Opdracht',
      },
      client: 'Gegevens klant',
      conditions: {
        description: 'Raadpleeg de algemene voorwaarden van deze offerte',
        title: 'Algemene voorwaarden',
      },
      createdBy: 'Deze offerte werd opgemaakt en verstuurd door',
      description: 'Beschrijving',
      expirationDate: 'Geldig tot',
      freelancer: 'Uitvoerder opdracht',
      introduction: 'Inleiding',
      specialConditions: 'Bijzondere voorwaarden',
      title: 'Titel',
    },
  },
  createEdit: {
    assignment: {
      description: 'Beschrijf kort wat je opdracht zoal inhoudt.',
      title: 'Opdracht',
    },
    attachments: {
      description: 'Voeg eventuele documenten toe aan deze offerte.',
      error: {
        delete: 'Er ging iets fout bij het verwijderen van de bijlage.',
      },
      title: 'Extra informatie aan jouw klant',
    },
    basicInfo: {
      description: 'Alle basisinformatie van jouw offerte.',
      title: 'Basisinformatie',
    },
    blocker: {
      message: 'Ben je zeker dat je de pagina wilt verlaten? Jouw wijzigingen aan de offerte werden nog niet opgeslagen.',
    },
    confirmation: {
      description:
        'Ben je zeker dat je de offerte wilt doorsturen? De offerte zal niet nagekeken worden en meteen verstuurd worden naar de klant.',
      submit: {
        create: 'Ja, verzend offerte',
        edit: 'Ja, bewerk offerte',
      },
      title: 'Je offerte wordt verzonden',
    },
    error: {
      title: 'Fout bij het laden van je offerte.',
    },
    lines: {
      description: 'Lijst hier de producten en/of diensten op die je aanbiedt.',
      title: 'Offertelijnen',
    },
    preview: 'Voorbeeld offerte',
    submit: {
      create: 'Verzend offerte',
      edit: 'Bewerk offerte',
      saveConcept: 'Opslaan',
      saveSend: 'Opslaan & versturen',
    },
    title: {
      create: 'Offertedetails',
      edit: 'Bewerk offerte',
    },
  },
  fields: {
    attachment: {
      label: 'Bijlage',
    },
    description: {
      label: 'Beschrijving',
    },
    entryNumber: {
      label: 'Offertenummer',
      last: 'Je laatste offerte heeft als nummer <0>{{entryNumber}}</0>.',
      placeholder: 'Offertenummer',
    },
    expirationDate: {
      label: 'Vervaldag offerte',
    },
    introduction: {
      label: 'Introductie',
    },
    mail: {
      default:
        '<p>\nDag #CLIENTNAME#,<br/><br/>\n\n#FREELANCERFIRSTNAME# heeft een offerte voor je opgemaakt. Kijk je deze even na?<br/><br/>\n\nHierzo: #QUOTATIONLINK#.<br/><br/>\n\nZodra jij je goedkeuring geeft, kan #FREELANCERFIRSTNAME# aan de slag.\n</p>',
      label: 'E-mail',
    },
  },
  header: {
    actionBlock: {
      button: 'Offerte aanmaken',
    },
    title: 'Offertes',
  },
  overview: {
    allowModal: {
      description: 'Ben je zeker dat je de offerte wilt markeren als goedgekeurd?',
      title: 'Markeer offerte als goedgekeurd',
    },
    columns: {
      client: 'Klant',
      date: 'Offertedatum',
      days: 'dagen',
      entryNumber: 'Offerte',
      status: {
        options: {
          Approved: 'Goedgekeurd',
          Draft: 'Concept',
          Expired: 'Vervallen',
          Rejected: 'Afgewezen',
          Sent: 'Verstuurd',
        },
        title: 'Status',
      },
      total: 'Totaal (excl. btw)',
    },
    declineModal: {
      description: 'Ben je zeker dat je de offerte wilt markeren als afgewezen?',
      title: 'Markeer offerte als afgewezen',
    },
    error: {
      title: 'Fout bij het laden van je offertes.',
    },
    rowActions: {
      allow: 'Goedkeuren',
      decline: 'Afwijzen',
      download: 'Download',
      duplicate: 'Kopieer',
      invoice: 'Maak factuur',
      preview: 'Bekijk offerte',
    },
  },
  quotationForClient: {
    error: {
      title: 'Fout bij het laden van de offerte.',
    },
  },
  richText: {
    shortcodes: {
      Clientname: 'Klantennaam',
      Freelancerfirstname: 'Voornaam freelancer',
      Quotationlink: 'Offertelink',
    },
  },
};
